export default {
  segment_labels: {
    active: 'Attivi',
    cancelled: 'Annullati',
    completed: 'Completati',
  },
};
